import useActivityKeyerContext from '/druid/private/useContext';

export default function useGetKeyByActivityId(): (activityId?: string) => string | undefined {
  return useActivityKeyerContext().getKeyByActivityId;
}
